import * as i0 from "@angular/core";
export class FirebaseSyncService {
    constructor() { }
}
FirebaseSyncService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FirebaseSyncService_Factory() { return new FirebaseSyncService(); }, token: FirebaseSyncService, providedIn: "root" });
